import {
  Button,
  createStyles,
  Grid,
  Modal,
  withStyles,
  type WithStyles,
} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import { useTranslations } from "adapters/i18n";
import React, { type ReactNode } from "react";

type FeatureDisclaimerModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  description: ReactNode;
} & WithStyles<typeof styles>;

function FeatureDisclaimerModal({
  classes,
  description,
  isOpen,
  onClose,
  title,
}: FeatureDisclaimerModalProps) {
  const { t } = useTranslations();

  return (
    <Modal
      id="feature-disclaimer-modal"
      data-testid="feature-disclaimer-modal"
      onBackdropClick={onClose}
      open={isOpen}
    >
      <div className={classes.modalRoot}>
        <Grid container className={classes.modalContainer}>
          <div className={classes.modalInfoHeader}>
            <Typography className={classes.title}>{title}</Typography>
            <CloseIcon className={classes.closeIcon} onClick={onClose} />
          </div>

          <Grid item xs={12}>
            <Typography className={classes.description} component="div">
              {description}
            </Typography>
          </Grid>

          <Grid item xs={12} className={classes.modalActions}>
            <Button
              autoFocus={true}
              className={classes.confirmationButton}
              color="primary"
              onClick={onClose}
              variant="contained"
            >
              {t("common:actions.ok")}
            </Button>
          </Grid>
        </Grid>
      </div>
    </Modal>
  );
}

const styles = () =>
  createStyles({
    modalRoot: {
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flex: 1,
    },
    modalContainer: {
      width: "490px",
      borderRadius: "16px",
      backgroundColor: "#ffffff",
      boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.5)",
    },
    modalInfoHeader: {
      display: "flex",
      flex: 1,
      alignItems: "center",
      justifyContent: "space-between",
      padding: "42px 40px 0px 39px",
    },
    title: {
      fontSize: "18px",
      fontWeight: 500,
      letterSpacing: "-0.1px",
      color: "rgba(51, 50, 56, 0.84)",
    },
    closeIcon: {
      width: "24px",
      height: "24px",
      cursor: "pointer",
      objectFit: "contain",
      padding: "0",
      color: "#333333",
    },
    modalActions: {
      display: "flex",
      justifyContent: "flex-end",
      padding: "42px 40px 29px 39px",
    },
    confirmationButton: {
      width: "83px",
      height: "36px",
      textTransform: "uppercase",
    },
    description: {
      fontFamily: "Roboto",
      fontSize: 16,
      fontStretch: "normal",
      padding: "29px 52px 0 39px",
      letterSpacing: "-0.03px",
      color: "#444444",
    },
  });

export default withStyles(styles)(FeatureDisclaimerModal);
